import { BsModal } from './BsModal';
export default BsModal;
